import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
const HighlightModeContext = createContext(undefined);
export const HighlightModeProvider = ({ value, children }) => (_jsx(HighlightModeContext.Provider, { value: value, children: children }));
export const useHighlightMode = () => {
    const ctx = useContext(HighlightModeContext);
    if (ctx === undefined) {
        throw new Error('useHighlightMode must be used within a HighlightModeProvider');
    }
    return ctx;
};
